import { useEffect, useRef } from "react";

const EVENT = "tadpole:organization-renamed";

export type RenamedOrganization = { id: number; name: string };

/**
 * Tells what shows the organization's name and keeps it (the navbar, the
 * dashboard switcher, the admin dashboard) that it was renamed, so the new
 * name shows without a reload.
 */
export function announceOrganizationRenamed(organization: RenamedOrganization) {
  window.dispatchEvent(
    new CustomEvent<RenamedOrganization>(EVENT, { detail: organization })
  );
}

/** Calls onRenamed with each organization renamed while mounted. */
export function useOrganizationRenamed(
  onRenamed: (organization: RenamedOrganization) => void
) {
  const latest = useRef(onRenamed);
  latest.current = onRenamed;
  useEffect(() => {
    const listener = (event: Event) =>
      latest.current((event as CustomEvent<RenamedOrganization>).detail);
    window.addEventListener(EVENT, listener);
    return () => window.removeEventListener(EVENT, listener);
  }, []);
}
